import { Button } from '@/components/ui/Button';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface AuthButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  variant?: 'primary' | 'ghost';
  children: ReactNode;
}

export function AuthButton({
  loading,
  variant = 'primary',
  children,
  disabled,
  className,
  type = 'button',
  ...props
}: AuthButtonProps) {
  return (
    <Button
      type={type}
      variant={variant}
      className={className ?? 'w-full'}
      disabled={disabled}
      loading={loading}
      {...props}
    >
      {loading ? 'Please wait…' : children}
    </Button>
  );
}
